import { defineComponent, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import PersonalityGraph from './graph'
import { CautionLevel, useStore } from './state'
import { CharacterDetail } from './characterDetail'
import { NonCautionView } from './nonCautionView'
import { TwoOrMore } from './twoMore'
import { OtherCharacter } from './otherCharacter'
import { savePDF } from './pdf'

const ExamResultComp = defineComponent({
  name: 'Component.ExamResult',
  setup () {
    const store = useStore()

    return () => {
      const { result } = store

      const cautions = result
        .filter(({ level }) => level >= CautionLevel.caution)
        .sort((a, b) => b.score - a.score)
      const noCautions = result.filter(x => x.level < CautionLevel.caution)

      return (
        <div>
          <div class="bg-gray-100">
            <div class="mx-auto desktop:max-w-screen-desktop desktop:flex desktop:pt-4">
              {/* 성격 유형 그래프 */}
              <div class="max-w-screen-tablet p-5 mx-auto desktop:max-w-none desktop:w-1/3 desktop:pt-0">
                <div class="bg-white rounded">
                  <PersonalityGraph />
                </div>
              </div>
              {/* 성격유형 결과 */}
              <div class="bg-white desktop:w-2/3 desktop:rounded">
                <div class="max-w-screen-tablet p-5 pt-8 mx-auto desktop:max-w-none desktop:p-8">
                  <div>
                    {/* 악동 상세 카드 */}
                    {cautions.length > 0 && (
                      <div>
                        <div>
                          {cautions.map(val => (
                            <CharacterDetail
                              class="py-16 first:pt-0"
                              {...val}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                    {cautions.length === 0 && <NonCautionView />}
                    {/* 주의/심각 2개 이상 */}
                    {cautions.length >= 2 && <TwoOrMore />}
                    {noCautions.length >= 1 && (
                      <OtherCharacter class="mt-4" noCautions={noCautions} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  },
})

export default defineComponent({
  name: 'Page.ExamResult',
  setup () {
    const store = useStore()
    const route = useRoute()

    onMounted(() => {
      const code = route.query.code as string
      let query = ''
      for (let i = 0; i < code.length; i += 2) {
        const hex = code.slice(i, i + 2)
        const ascii = parseInt(hex, 16)
        query += String.fromCharCode(ascii)
      }

      const scores = query.split(';').map(Number)

      store.setScores([
        {
          character: 'umgyuk',
          score: scores[0],
        },
        {
          character: 'mulung',
          score: scores[1],
        },
        {
          character: 'godok',
          score: scores[2],
        },
        {
          character: 'kongkong',
          score: scores[3],
        },
        {
          character: 'buruk',
          score: scores[4],
        },
      ])
    })

    const saveToPDF = () => {
      store.showOtherCharacter = true
      store.showTwoMore = true
      setTimeout(() => {
        savePDF(document.querySelector('#to_pdf'))
      }, 300)
    }

    return () => (
      <div id="to_pdf" class="leading-6">
        <div class="text-center p-4 font-bold shadow-sm flex justify-center items-center">
          <div>스키마 검사 결과</div>
          <div
            class="ml-4 border p-2 rounded cursor-pointer hover:bg-gray-100"
            onClick={saveToPDF}
          >
            pdf로 저장하기
          </div>
        </div>
        <ExamResultComp />
        <style>
          {`
            body {
              line-height: 0.5 !important;
            }
          `}
        </style>
      </div>
    )
  },
})
